import React from 'react';
import { Navigation } from '../components/Navigation';
import { DDHero } from '../components/dd/DDHero';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { DDServices } from '../components/dd/DDServices';
import { DDFAQ } from '../components/dd/DDFAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { CallbackWidget } from '../components/CallbackWidget';
export function DDPage() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-417">
      <Navigation data-id="element-418" />

      <main data-id="element-419">
        <DDHero data-id="element-420" />
        <WhyChooseUs data-id="element-421" />
        <DDServices data-id="element-422" />
        <DDFAQ data-id="element-423" />
        <Testimonials data-id="element-424" />
        <Consultation data-id="element-425" />
      </main>

      <Footer data-id="element-426" />
      <CookieBanner data-id="element-427" />
      <CallbackWidget data-id="element-428" />
    </div>;
}